// extracted by mini-css-extract-plugin
export default {"cards":"MyArea_cards__naGZ8","card":"MyArea_card__n6I4v","item":"MyArea_item__9FUUO","item__icon":"MyArea_item__icon__384L4","item__text":"MyArea_item__text__6OAN0"};